import React,{useEffect} from "react";
import { FieldArray, Form, Formik } from "formik";
import FormikControl from "../../Components/LifeInsFormikComponent/FormikControl";
import CreateQuoteArray from "./CreateQuoteArray";

const CommunitiObject = (props) => {
  const { name, Field, parent, array, Mparent,Aindex,page,customErrors,setCustomErrors,AddHandler,arrayIndex,nomineeShare,
    setNomineeShare,} = props;
  // console.log(name, Field);


  useEffect(() => {
    
    
   
  }, [])
  
  return (
    <>
      <div>
        <div>
          {Field.name==="adoptedfrom"?<div><b>{Field.label}</b></div>:<div><b>{Field.label}</b></div>}
        </div>
        <div>
          {Object.keys(Field).length > 0
            ? Field.obj.map((field, index) => {
                return (
                  <div>
                    {field.htmlElement === "TextField" ? (
                      <div className="mb-3" key={index} hidden={field.hidden}>
                        <FormikControl
                          control="input"
                          name={`${name}.${field.name}`}
                          manualValidation={field.manualValidation}
                          readOnly={field.readOnly}
                          url={field.url}
                          label={field.label}
                          AddHandler={AddHandler}
                          type={field.dataType}
                          page={page}
                          customErrors={customErrors}
                          setCustomErrors={setCustomErrors}
                          nomineeShare={nomineeShare}
                          setNomineeShare={setNomineeShare}
                        />
                      </div>
                    ) : field.htmlElement === "Select" ? (
                      <div className="mb-3" key={index} hidden={field.hidden}>
                        <FormikControl
                          control="select"
                          readOnly={field.readOnly}
                          name={`${name}.${field.name}`}
                          label={field.label}
                          type={field.dataType}
                          options={field.options}
                          page={page}
                          arrayIndex={arrayIndex}
                        />
                      </div>
                    ) : field.htmlElement === "TextArea" ? (
                      <div className="mb-3" key={index} hidden={field.hidden}>
                        <FormikControl
                          control="textarea"
                          name={`${name}.${field.name}`}
                          label={field.label}
                          type={field.dataType}
                          page={page}
                        />
                      </div>
                    ) : field.htmlElement === "Radio" ? (
                      <div className="mb-3" key={index} hidden={field.hidden}>
                        <FormikControl
                          control="radio"
                          name={`${name}.${field.name}`}
                          options={field.options}
                          manualValidation={field.manualValidation}
                          label={field.label}
                          type={field.dataType}
                          parent={parent}
                          Aindex={Aindex}
                          array={array}
                          page={page}
                          subparent={Field.name}
                          // subparent={}
                        />
                      </div>
                    ) : field.htmlElement === "DatePicker" ? (
                      <div className="mb-3" key={index} hidden={field.hidden}>
                        <FormikControl
                          control="date"
                          name={`${name}.${field.name}`}
                          errors={field.errors}
                          readOnly={field.readOnly}
                          label={field.label}
                          type={field.dataType}
                          page={page}
                          arrayIndex={arrayIndex}
                        />
                      </div>
                    ) : field.htmlElement === "checkbox" ? (
                      <div className="mb-3" key={index} hidden={field.hidden}>
                        <FormikControl
                          control="checkbox"
                          name={`${name}.${field.name}`}
                          errors={field.errors}
                          label={field.label}
                          type={field.dataType}
                          options={field.options}
                          page={page}
                        />
                      </div>
                    ) : field.htmlElement === "Time" ? (
                      <div className="mb-3" key={index} hidden={field.hidden}>
                        <FormikControl
                          control="time"
                          name={`${name}.${field.name}`}
                          errors={field.errors}
                          label={field.label}
                          type={field.dataType}
                          options={field.options}
                          page={page}
                        />
                      </div>
                    ) : field.htmlElement === "File" ? (
                      <div
                        className="mb-3"
                        key={index}
                        hidden={field.hidden}
                        id={`${Field.name}.${field.name}`}
                      >
                        <FormikControl
                          control="file"
                          name={`${name}.${field.name}`}
                          parent={Field.name}
                          errors={field.errors}
                          label={field.label}
                          type={field.dataType}
                          options={field.options}
                          page={page}
                        />
                      </div>):
                      field.htmlElement === "Object" ? (
                        <div
                          className="mb-3"
                          key={index}
                          hidden={field.hidden}
                          id={`${name}.${field.name}`}
                        >
                          <CommunitiObject
                           
                            name={`${name}.${field.name}`}
                            Field={field}
                            page={page}
                            customErrors={customErrors}
                            setCustomErrors={setCustomErrors}
                            nomineeShare={nomineeShare}
                            setNomineeShare={setNomineeShare}
                          />
                        </div>):
                        field.htmlElement === "Array" ? (
                          <div
                            className="mb-3"
                            key={index}
                            hidden={field.hidden}
                            id={`${Field.name}.${field.name}`}
                          >
                            <CreateQuoteArray
                             
                              name={`${name}.${field.name}`}
                              Field={field}
                              page={page}
                              nomineeShare={nomineeShare}
                            setNomineeShare={setNomineeShare}
                            />
                          </div>):null}
                  </div>
                );
              })
            : null}
        </div>
      </div>
    </>
  );
};
export default CommunitiObject;
